import React, { useEffect, useMemo, useState } from 'react'
import { Box, Skeleton, Stack } from '@mui/material';
import { CheckoutPageTable } from './CheckoutPageTable';
import { Delete, SubscribeToGetAll, Push, Update } from '../../../apis/Admin/Checkout';
import TreeAPI from '../../../apis/TreeAPI';
import produce, { nothing } from 'immer';
import { sleep } from '../../../helpers/HelperObj';
const getUniqueId = () => `${new Date().getTime() * 50}`;
const CheckoutPageDashboard = (props: ICheckoutPageDashboardProps) => {
    const { courseId } = props;
    const [checkoutPages, setCheckoutPages] = useState<ICheckoutPage[] | undefined>(undefined);
    const [episodesFull, setEpisodesFull] = useState<{
        [key: string]: IEpisode | undefined
    }>({});
    const [courses, setCourses] = useState<{
        [key: string]: ICourse | undefined
    }>({});
    const course = useMemo(() => {
        const courseObj = courses[courseId];
        if (courseObj === undefined) return undefined;

        return courseObj;
    }, [courseId, courses]);
    useEffect(() => {
        const unsubscribe = SubscribeToGetAll(
            (payload) => {
                setCheckoutPages(payload);
            });

        return () => unsubscribe();
    }, []);

    useEffect(() => {
        const unsubscribe = TreeAPI.subscribeToCourses(
            (course: ICourse) => {
                setCourses(
                    produce(draft => {
                        draft[course.id] = course;
                    })
                );
            },
            (id: string) => {
                setCourses(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );

        return () => unsubscribe();
    }, []);


    useEffect(() => {
        const unsubscribe = TreeAPI.subscribeToEpisodes(
            (episode: IEpisode) => {
                setEpisodesFull(
                    produce(draft => {
                        draft[episode.id] = episode;
                    })
                );
            },
            (id: string) => {
                setEpisodesFull(
                    produce(draft => {
                        draft[id] = undefined;
                    })
                );
            }
        );
        return () => unsubscribe();
    }, []);

    const episodesByCourse = useMemo(() => {
        if (course === undefined) return undefined;

        const episodesObj = course.episodes;
        if (episodesObj === undefined) return [];

        let arr: IEpisode[] = [];
        Object.keys(episodesObj).forEach(episodeKey => {
            if (
                typeof episodesObj[episodeKey] === 'boolean' &&
                episodesObj[episodeKey] === true
            ) {
                const episodeObj = episodesFull[episodeKey];
                if (episodeObj === undefined) return;
                arr.push(episodeObj);
            } else return;
        });

        arr.sort((a, b) => a.order - b.order);
        return arr;

    }, [episodesFull, course]);
    return (
        <Box component="section" sx={{ p: 2 }}>
            {(
                checkoutPages !== undefined &&
                episodesByCourse !== undefined &&
                course !== undefined) ? (
                <CheckoutPageTable
                    onBeforeNew={() => ({
                        publicId: getUniqueId(),
                        marketingVideoURL: undefined,
                        codes: [],
                        timers: [],
                        course: {
                            id: courseId,
                            name: course.title,
                            levels: episodesByCourse.map(episode => ({
                                id: episode.id,
                                name: episode.title,
                                activation: undefined
                            }))
                        }
                    })}
                    data={checkoutPages}
                    onChange={async (data, context) => {
                        switch (context.operation) {
                            case 'NEW':
                                await Push(context.payload);
                                break;
                            case 'EDIT':
                                await Update(context.payload);
                                break;
                            case 'DELETE':
                                await Delete(context.payload.publicId);
                                break;
                        }
                        // await sleep(3000);
                        setCheckoutPages(data);
                    }}
                />
            ) : (
                <Stack spacing={2}>
                    <Skeleton animation='pulse' variant="rounded" height={50} />
                    <Skeleton animation='pulse' variant="rounded" height={20} />
                    <Skeleton animation='pulse' variant="rounded" height={20} />
                    <Skeleton animation='pulse' variant="rounded" height={20} />
                    <Skeleton animation='pulse' variant="rounded" height={20} />
                    <Skeleton animation='pulse' variant="rounded" height={50} />
                </Stack>
            )}
        </Box>
    );

};

export { CheckoutPageDashboard };